import React from "react";
import usePowerBIEmbed from "../../hooks/usePowerBIEmbed";
import usePowerBIButtonNavigation from "../../hooks/usePowerBIButtonNavigation";
import PowerBIEmbedOptimized from "../power-bi/PowerBIEmbedOptimized";
import HTLoader from "../common/ht-loader/HTLoader";
import { PowerBINavigationProvider } from "../../contexts/PowerBINavigationContext";
import "./BookingPace.scss";
import "../power-bi/report.scss";

const REPORT_CLASS = "report-container";

const BookingPaceContent = () => {
  // Get button navigation handlers (pass null initially, will update with report instance below)
  const buttonHandlers = usePowerBIButtonNavigation(null);

  const {
    report,
    bootstrapConfig,
    reportConfig,
    isBootstrapped,
    isEmbedded,
    isLoaded,
    eventHandlersMap,
    handleEmbedComponent,
  } = usePowerBIEmbed(
    "Booking Pace",
    buttonHandlers, // Pass button handlers as additionalEventHandlers
    "Booking Pace",
    "Booking Pace"
  );

  // Update button navigation hook with report instance once it's available
  usePowerBIButtonNavigation(report);

  return (
    <section className="booking-pace">
      <div
        className="booking-pace-iframe-container"
        data-testid="booking-pace-iframe-container"
      >
        {!isLoaded && <HTLoader loaderText="" />}
        <PowerBIEmbedOptimized
          bootstrapConfig={bootstrapConfig}
          embedConfig={reportConfig}
          isBootstrapped={isBootstrapped}
          isEmbedded={isEmbedded}
          cssClassName={REPORT_CLASS + (isLoaded ? "" : " invisible")}
          getEmbeddedComponent={handleEmbedComponent}
          eventHandlers={eventHandlersMap}
          uniqueId="booking-pace"
        />
      </div>
    </section>
  );
};

// Wrap with PowerBINavigationProvider to enable navigation context
const BookingPace = () => {
  return (
    <PowerBINavigationProvider>
      <BookingPaceContent />
    </PowerBINavigationProvider>
  );
};

export default BookingPace;
